<template>

<div class="input" :class="{'has-value': value, 'is-errored': errored, 'is-expand': expand, 'is-slim': slim || !window.is.desktop, 'is-stacked': stacked}">

	<div class="input-content">

		<div class="input-content-label" v-if="label">{{ label }}</div>

		<div class="input-content-input">

			<slot></slot>

		</div>

	</div>

	<div class="input-note" v-if="note">{{ note }}</div>

</div>

</template>

<script>

export default {

	props: ['label', 'expand', 'note', 'errored', 'value', 'stacked', 'slim']

}

</script>

<style scoped>

.input {
	width: 100%;
	display: flex;
	flex-direction: column;
}

.is-tablet .input,
.is-mobile .input {
    margin-bottom: 10px;
}

.input-content {
	display: flex;
	flex-direction: row;
}

.input.is-slim .input-content {
    flex-direction: column;
}

.input-content-label {
	flex-shrink: 0;
	width: 120px;
	line-height: 40px;
	color: var(--color-grey-dark);
	font-size: 14px;
	font-weight: 300;
}

.input.is-expand .input-content-label {
    flex-grow: 1;
    width: auto;
}

.input.is-slim .input-content-label {
    width: 100%;
    line-height: 18px;
    margin-bottom: 5px;
    margin-left: 2px;
}

.input-content-input {
	flex-grow: 1;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
}

.input.is-slim .input-content-input,
.input.is-stacked .input-content-input {
    flex-direction: column;
    align-items: initial;
}

.input-note {
	font-size: 10px;
	line-height: 12px;
	padding: 5px 10px 2px 10px;
	font-weight: 300;
	color: var(--color-grey-dark);
}

</style>